import {
  IonList,
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
  IonInput,
  IonText
} from "@ionic/react";
import { PROFILE_FIELDS } from "../../../utils/constants";
import React, { useEffect } from "react";
import ParkLocation from "../../../utils/ParkLocation";
import MobileNumber from "../../../utils/MobileNumber/MobileNumber";
import { normalizeInput, updatedRoles } from "../../../pages/Manage/ManageUser/ManageUserUtil";
import { removeSpecial } from "../userProfile/userProfileUtil";
import { isElevatedLeasedOwenerOprRole, isElevatedLeasedOwenerOprRoleOnSelectedUser, isLeasedOwnerOprRoleOnly, isLeasedOwnerOprRoleOnlyOnSelectedUser, isLeasedOwnerOprRoleOnSelectedUser } from "../../../utils/roleUtil/RoleUtil";

const ManageUserFormFields = (props: any) => {

  useEffect(() => {
    props.setRestrictUserModalProps({isModalOpen: false})
  }, []);

  useEffect(() => {
    props.validateForm(props.formErrors, props.formFields, props.isFormEdit);
  }, [props.formErrors, props.formFields]);

  useEffect(() => {
    if (!props.selectedUser) {
      props.resetData();
    }
  }, []);

  const size = "12";
  return (
    <>
      {!props.mobileValidateError && (props.isUserNotExist || props.isEdit) ? (
        <>
          <IonList className="manage-userslist-form">
            <IonRow>
              <IonCol size={size}>
                <IonItem className="user-profile-item">
                  <IonLabel
                    className="user-profile-label"
                    position="floating"
                    mode={"ios"}
                  >
                    {PROFILE_FIELDS.FIRST_NAME}
                  </IonLabel>
                  <IonInput
                    type="text"
                    onIonChange={props.handleChange}
                    value={props.formFields["firstName"]}
                    name="firstName"
                    data-testid="firstName"
                    class="user-profile-input"
                  ></IonInput>
                </IonItem>
                {props.formErrors && props.formErrors["firstName"] ? (
                  <IonText
                    class="field-error"
                    data-test="firstName-field-error"
                  >
                    {props.formErrors["firstName"]}
                  </IonText>
                ) : null}
              </IonCol>
              <IonCol size={size}>
                <IonItem className="user-profile-item">
                  <IonLabel
                    className="user-profile-label"
                    position="floating"
                    mode={"ios"}
                  >
                    {PROFILE_FIELDS.LAST_NAME}
                  </IonLabel>
                  <IonInput
                    type="text"
                    name={"lastName"}
                    onIonChange={props.handleChange}
                    value={props.formFields["lastName"]}
                    class="user-profile-input"
                  ></IonInput>
                </IonItem>
                {props.formErrors && props.formErrors["lastName"] ? (
                  <IonText class="field-error" data-test="lastName-field-error">
                    {props.formErrors["lastName"]}
                  </IonText>
                ) : null}
              </IonCol>
              <IonCol size={size}>
                <IonItem className="user-profile-item">
                  <IonLabel
                    className="user-profile-label"
                    position="floating"
                    mode={"ios"}
                  >
                    {PROFILE_FIELDS.EMAIL_ADDRESS}{" "}
                    {props.isonlyDriverSelected ? "(Optional)" : ""}
                  </IonLabel>
                  <IonInput
                    value={props.formFields.email}
                    type="email"
                    name="emailAddress"
                    data-testid="email-field"
                    class="user-profile-input"
                    onIonBlur={props.handleChange}
                    readonly={props.isEdit}
                  ></IonInput>
                </IonItem>
                {props.formErrors && props.formErrors["emailAddress"] ? (
                  <IonText class="field-error" data-test="mobile-field-error">
                    {props.formErrors["emailAddress"]}
                  </IonText>
                ) : null}
              </IonCol>
                  {props.selectedUser ? (
                    <IonCol size={size}>
                      <IonItem className="user-profile-item">
                        <MobileNumber
                          mobileNumber={normalizeInput(props.formFields["mobileNumber"])}
                          mobileReadOnly={true}
                          name="mobileNumber"
                          placeholder=""
                          label={PROFILE_FIELDS.MOBILE_NUMBER}
                          countryCodefromMember={removeSpecial(props.selectedUser?.mobileNumber)?.slice(0, -10)}
                          nonEditableField={true}
                        />
                      </IonItem>
                    </IonCol>
                  ) : null}
                  {(props.isDriverSelected || isLeasedOwnerOprRoleOnSelectedUser(updatedRoles(props?.formFields?.roles)) || isLeasedOwnerOprRoleOnlyOnSelectedUser(props?.selectedUser?.roles) || isElevatedLeasedOwenerOprRoleOnSelectedUser(props?.selectedUser?.roles)) && (
                    <>
                      <IonCol size={size}>
                        <ParkLocation
                          value={props.formFields["addressDTOs"]}
                          handleValueChange={props.handleChange}
                          cssClass={"user-profile-item"}
                          handelLabel={true}
                        />
                      </IonCol>
                      <IonCol size={size}>
                        <IonItem className="user-profile-item">
                          <IonLabel
                            className="user-profile-label"
                            position="floating"
                            mode={"ios"}
                          >
                            {PROFILE_FIELDS.TRACKTOR_NUMBER}
                          </IonLabel>
                          <IonInput
                            type="text"
                            name={"tractorNumber"}
                            data-testid="tractor-field"
                            onIonChange={props.handleChange}
                            value={props.formFields["tractorNumber"]}
                            class="user-profile-input"
                            maxlength={15}
                          ></IonInput>
                        </IonItem>
                        {props.formErrors &&
                        props.formErrors["tractorNumber"] ? (
                          <IonText
                            class="field-error"
                            data-test="tractorNumber-field-error"
                          >
                            {props.formErrors["tractorNumber"]}
                          </IonText>
                        ) : null}
                      </IonCol>
                    </>
                  )}

              <IonCol size={size}>
                <IonItem className="user-profile-item">
                  <IonLabel
                    className="user-profile-label"
                    position="floating"
                    mode={"ios"}
                  >
                    {PROFILE_FIELDS.CARRIER_ID}
                  </IonLabel>
                  <IonInput
                    type="text"
                    name={"carrierId"}
                    value={
                      props.formFields["carrierId"]
                        ? props.formFields["carrierId"]
                        : "NA"
                    }
                    readonly
                    class="user-profile-input"
                  ></IonInput>
                  {!!props.formFields["carrierId"] && (
                    <img
                      slot="end"
                      alt="delink"
                      src="assets/icon/Carrier_delink.svg"
                      className="delink"
                      data-testid="delink-btn"
                      onClick={props.handleDelinkClick}
                    />
                  )}
                </IonItem>
              </IonCol>
            </IonRow>
          </IonList>
        </>
      ) : null}
    </>
  );
};

export default ManageUserFormFields;
